import Firebase from 'EnoticeFirebase';

// NOTE: For refactoring, there may be a way to derive this from the Redux auth state rather than having a dedicated helper function.
export const isAnonymousFlow = () => !!Firebase.auth().currentUser?.isAnonymous;
